import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useI18n } from "../i18n";
import { useAuth } from "../AuthContext";
import { fmtErr } from "../api";
import useNoIndex from "../useNoIndex";

export default function Register() {
  useNoIndex();
  const { t } = useI18n();
  const { register } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await register(email, password, name);
      nav("/dashboard", { replace: true });
    } catch (e) {
      setErr(fmtErr(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  }
  function googleLogin() {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  }

  return (
    <div className="container-cd py-20" data-testid="register-page">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="overline" style={{ color: "var(--orange)" }}>FREE · NO CARD</div>
          <h1 className="font-display text-5xl md:text-6xl mt-6 leading-[0.9]">{t("auth.register.title")}</h1>
          <p className="mt-6 text-base" style={{ color: "var(--ink-2)", maxWidth: 360 }}>
            {t("auth.have_account")}{" "}
            <Link to="/login" className="underline hover:text-[color:var(--orange)]">
              {t("auth.submit.login")}
            </Link>
          </p>
        </div>
        <div className="md:col-span-7 max-w-md">
          <div className="cd-card p-8">
            <form onSubmit={onSubmit} className="space-y-6">
              <div>
                <label className="overline">{t("auth.name")}</label>
                <input
                  className="cd-input mt-2"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  data-testid="register-name-input"
                />
              </div>
              <div>
                <label className="overline">{t("auth.email")}</label>
                <input
                  className="cd-input mt-2"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="register-email-input"
                />
              </div>
              <div>
                <label className="overline">{t("auth.password")}</label>
                <input
                  className="cd-input mt-2"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  minLength={6}
                  data-testid="register-password-input"
                />
              </div>
              {err ? (
                <div className="font-mono text-xs px-3 py-2" style={{ background: "var(--red)", color: "white" }} data-testid="register-error">
                  {err}
                </div>
              ) : null}
              <button
                type="submit"
                className="btn btn-primary w-full"
                disabled={loading}
                data-testid="register-submit-btn"
              >
                {loading ? t("common.loading") : t("auth.submit.register")}
              </button>
            </form>
            <div className="my-6 text-center overline" style={{ color: "var(--ink-2)" }}>{t("auth.or")}</div>
            <button onClick={googleLogin} className="btn btn-ghost w-full" data-testid="register-google-btn">
              {t("auth.google")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
